/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HelpTooltip/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function HelpTooltip({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Content/Display/DeleteAction/Content/HelpTooltip",
  hovered,
  width
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={!hovered}>
<No
  viewPath={`${viewPath}/No`}
 hovered={hovered}
/>
</fromFlow.When>
<fromFlow.When is={hovered}>
<Content
  viewPath={`${viewPath}/Content`}
 width={width}
 hovered={hovered}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}